module.exports = {
          srcSet: __webpack_public_path__ + "3262d95b.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "3262d95b.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "3262d95b.jpg",
          toString:function(){return __webpack_public_path__ + "3262d95b.jpg"},
          
          width: 330,
          height: 200
        }